import { IdmsErrorTable } from '@/components/Analysis/Idms/IdmsErrorTable';
import { useAtom } from 'jotai';
import * as state from '../state';
import {  xlsxBase64ToJson } from '@/components/Analysis/Idms/utils';
import { TemplateValidationError } from '@/components/Analysis/Idms/types';
import { Box, Button, IconButton, Modal, Paper, Stack, Typography } from '@mui/material';
import { ValidationsErrorDialogStyles } from '@/components/Analysis/modules/pointOfInterest/BulkUpload/components/styles';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CloseIcon from '@mui/icons-material/Close';
import { useState, useEffect } from 'react';

export const ServiceGroupUploadErrorTableModal = () => {
  const [serviceGroupUploadState, setServiceGroupUploadState] = useAtom(
    state.serviceGroupUploadState
  );
  const [header, setHeader] = useState<string[]>([]);
  const [rows, setRows] = useState<Array<Record<string, unknown>>>([]);

  const isOpen = serviceGroupUploadState.state === 'csv-error';
  const error = serviceGroupUploadState.error?.extensions?.error;

  // Handle async file processing
  useEffect(() => {
    const processFile = async () => {
      if (!serviceGroupUploadState.inputCsv || !isOpen) return;
      
      try {
        const result = await xlsxBase64ToJson(serviceGroupUploadState.inputCsv);
        setHeader(result.header);
        setRows(result.rows);
      } catch (err) {
        console.error('Error processing file:', err);
      }
    };

    processFile();
  }, [serviceGroupUploadState.inputCsv, isOpen]);

  // No error means no need to show the modal, this helps with the initial render to not crash the modal
  // Also, if the inputCsv is not set, we don't want to show the modal
  if (
    !error ||
    !serviceGroupUploadState.inputCsv ||
    serviceGroupUploadState.state !== 'csv-error'
  ) {
    return null;
  }

  const onClose = () => {
    setServiceGroupUploadState({
      ...serviceGroupUploadState,
      state: 'idle',
      error: undefined,
      inputCsv: undefined,
    });
  };

  const triggerReupload = () => {
    serviceGroupUploadState.inputRef?.click?.();
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Paper
        sx={{
          ...ValidationsErrorDialogStyles,
          overflow: 'auto',
          overflowY: 'auto',
        }}
      >
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography fontWeight={'bold'} fontSize={20} my={2}>
            The file contains errors
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Typography sx={{ mb: 1 }}>
          Note: This file cannot be uploaded due to exceptions highlighted in the table below. 
          Hover over each highlighted value to view the specific exception.
        </Typography>
          <IdmsErrorTable
            header={header}
            rows={rows}
            errors={
              serviceGroupUploadState.error?.extensions?.error as Array<TemplateValidationError>
            }
            footer={
              <Box sx={{ mt: 1, width: '100%', display: 'flex' }} justifyContent={'flex-end'}>
                <Button id="service-group-upload-error-modal-close-button" onClick={onClose}>
                  Cancel
                </Button>
                <Button
                  id="service-group-upload-error-modal-reupload-button"
                  onClick={triggerReupload}
                  variant="contained"
                  color="primary"
                  startIcon={<FileUploadIcon />}
                  sx={{ ml: 2 }}
                >
                  Re Upload
                </Button>
              </Box>
            }
          />
      </Paper>
    </Modal>
  );
};
